import { Organisation } from "../../AppDataProvider/types";

export const isFeatureFlagEnabledForOrganisation = (
  featureFlag: string,
  organisation: Organisation,
): boolean => {
  const { enabledFeatureFlags } = organisation;
  return enabledFeatureFlags?.includes(featureFlag) ?? false;
};
